import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-20" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium" }, "1. Wybór leku", -1)
const _hoisted_3 = { class: "my-20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium" }, "2. Wywiad medyczny", -1)
const _hoisted_5 = { class: "mt-20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium mt-12" }, "3. Dane pacjenta", -1)


import MedicationChoose from '../shared/MedicationChoose/MedicationChoose.vue';
import ProductForm from '../shared/ProductForm.vue';
import { formSchema } from './schema';
import { initialValues } from './initialValues';
import IsPregnatField from '../shared/Fields/IsPregnatField.vue';
import PatientData from '../shared/PatientData.vue';
import UploadedFileField from '../shared/Fields/UploadedFileField.vue';
import AdditionalDiseasesField from '../shared/Fields/AdditionalDiseasesField.vue';
import HasOperationsField from '../shared/Fields/HasOperationsField.vue';
import DrugWasField from '../shared/Fields/DrugWasField.vue';
import ImportantInformationField from '../shared/Fields/ImportantInformationField.vue';

export default {
  __name: 'Erecepta',
  props: {
    checkoutlink: { type: String, required: true },
    price: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
},
  setup(__props) {

const props = __props;



return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(ProductForm, {
    schema: _unref(formSchema),
    initialValues: _unref(initialValues),
    id: __props.id,
    checkoutlink: __props.checkoutlink,
    price: __props.price
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(MedicationChoose)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(IsPregnatField),
        _createVNode(AdditionalDiseasesField, {
          isExtended: true,
          title: "Czy ma Pan(i) jakiekolwiek obciążenia chorobowe (np. nadciśnienie)?"
        }),
        _createVNode(HasOperationsField, { isExtended: true }),
        _createVNode(DrugWasField),
        _createVNode(ImportantInformationField),
        _createVNode(UploadedFileField, {
          "has-tooltip": true,
          title: "Dokumentacja medyczna"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(PatientData)
      ])
    ]),
    _: 1
  }, 8, ["schema", "initialValues", "id", "checkoutlink", "price"]))
}
}

}